/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteDataResult
 */
export interface DeleteDataResult {
    /**
     * 
     * @type {number}
     * @memberof DeleteDataResult
     */
    deleteCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeleteDataResult
     */
    dryRun: boolean;
}

/**
 * Check if a given object implements the DeleteDataResult interface.
 */
export function instanceOfDeleteDataResult(value: object): value is DeleteDataResult {
    if (!('deleteCount' in value) || value['deleteCount'] === undefined) return false;
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    return true;
}

export function DeleteDataResultFromJSON(json: any): DeleteDataResult {
    return DeleteDataResultFromJSONTyped(json, false);
}

export function DeleteDataResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteDataResult {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteCount': json['deleteCount'],
        'dryRun': json['dryRun'],
    };
}

export function DeleteDataResultToJSON(json: any): DeleteDataResult {
    return DeleteDataResultToJSONTyped(json, false);
}

export function DeleteDataResultToJSONTyped(value?: DeleteDataResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deleteCount': value['deleteCount'],
        'dryRun': value['dryRun'],
    };
}

